import React from 'react';
import { Box } from 'grommet';

export const MapTabContent = ({ ...rest }) => (
  <Box pad={{ vertical: 'medium' }} {...rest} />
);